import ShoppingCartOutline from '@monofront/design-system/visuals/Icons/Old/ShoppingCartOutline';
import AddCart from '@monofront/design-system/visuals/Icons/Old/AddCart';
import { format } from '@monofront/business/utils';
import { useShoppingCart } from '@hooks/cart/useShoppingCart';
import useShouldHideTotalPrice from '@hooks/useShouldHideTotalPrice';
import { useTranslations } from 'next-intl';

type ShoppingCartIconProps = {
  iconColor?: string;
};

const ShoppingCartIcon: React.FC<ShoppingCartIconProps> = ({
  iconColor = 'tw-text-black group-hover:tw-text-red-600',
}) => {
  const { shoppingCart } = useShoppingCart();
  const shouldHideTotalPrice = useShouldHideTotalPrice();
  const tCart = useTranslations('Cart');
  const { totalPrice = 0, totalQuantity = 0 } = shoppingCart;

  return (
    <span className="tw-group tw-relative tw-flex tw-max-h-8 tw-flex-row tw-items-center tw-transition-all desktop:tw-flex-col">
      <span className="sr-only">{tCart(`myCart`)}</span>
      <span className="tw-relative tw-mr-1 tw-max-h-6 desktop:tw-max-h-8">
        {totalPrice ? (
          <AddCart
            className={`tw-max-h-6 tw-w-6 desktop:tw-max-h-8 desktop:tw-w-8 tw-transition-all${` ${iconColor}`}`}
            aria-hidden="true"
          />
        ) : (
          <ShoppingCartOutline
            className={`tw-max-h-6 tw-w-6 desktop:tw-max-h-8 desktop:tw-w-8 tw-transition-all${` ${iconColor}`}`}
            aria-hidden="true"
          />
        )}
        {totalQuantity > 0 && (
          <span
            className="tw-lf-body-regular-xsm tw-absolute tw-right-1 tw-top-0 tw-flex tw-size-3.5 tw-items-center tw-justify-center tw-rounded-full tw-bg-red-600 tw-text-center tw-text-[0.5rem] tw-text-white desktop:tw-right-1.5 desktop:tw-size-4 desktop:tw-text-[0.625rem]"
            data-testname="ShoppingCart-Count"
          >
            {totalQuantity}
            <span className="sr-only">{tCart(`srProductsInCart`)}</span>
          </span>
        )}
      </span>
      {totalPrice > 0 && !shouldHideTotalPrice && (
        <span className="tw-text-black tw-lf-body-xbold-sm tw-w-full tw-text-center tw-text-xs">
          <span className="sr-only">{tCart(`srCartTotal`)}</span>
          {format(totalPrice)}
        </span>
      )}
    </span>
  );
};

export default ShoppingCartIcon;
